//#region src/helpers/asRecord.ts
function e(e) {
	return typeof e == "object" && e && !Array.isArray(e) ? e : null;
}
//#endregion
//#region src/parseApiErrorResponse.ts
function t(t) {
	let n = e(t);
	if (!n) return null;
	let { error_code: r, title: i, detail: a, status: o, field: s, meta: c } = n;
	return typeof r != "string" || r.length === 0 || typeof i != "string" || typeof a != "string" || typeof o != "number" ? null : {
		status: o,
		error_code: r,
		field: typeof s == "string" ? s : void 0,
		title: i,
		detail: a,
		meta: e(c) ?? void 0
	};
}
function n(n) {
	let r = e(n);
	if (!r || !Array.isArray(r.errors) || r.errors.length === 0) return null;
	let i = [];
	for (let e of r.errors) {
		let n = t(e);
		if (!n) return null;
		i.push(n);
	}
	let a = Array.isArray(r.stack) && r.stack.every((e) => typeof e == "string");
	return {
		errors: i,
		trace_id: typeof r.trace_id == "string" ? r.trace_id : void 0,
		cause: typeof r.cause == "string" ? r.cause : void 0,
		stack: a ? r.stack : void 0
	};
}
//#endregion
//#region src/transformToApiError.ts
function r(t) {
	let n = e(t);
	return n !== null && typeof n.detail == "string" && Array.isArray(n.items);
}
function i(t) {
	if (r(t)) return t;
	let i = e(t) ?? {}, a = e(i.response), o = a?.data, s = typeof i.message == "string" ? i.message : "", c = typeof a?.status == "number" ? a.status : void 0, l = typeof i.stack == "string" ? i.stack : void 0, u = n(o);
	if (u?.errors?.length) {
		let [e] = u.errors, t = {};
		return u.cause !== void 0 && (t.cause = u.cause), {
			code: e.error_code,
			detail: e.detail,
			context: t,
			stack: l,
			items: u.errors,
			traceId: u.trace_id,
			httpStatus: c
		};
	}
	let d = e(o) ?? {}, f = typeof d.code == "string" || typeof d.code == "number" ? d.code : void 0, p = typeof d.detail == "string" && d.detail.length > 0 ? d.detail : void 0, m = typeof d.stack == "string" ? d.stack : void 0;
	return {
		code: f ?? c,
		detail: p ?? s,
		context: e(d.context) ?? {},
		stack: m ?? l,
		items: [],
		traceId: void 0,
		httpStatus: c
	};
}
//#endregion
//#region src/findApiErrorItem.ts
function a(e, t) {
	let { items: n } = i(e);
	return n.length === 0 ? null : t ? n.find((e) => t.includes(e.error_code)) ?? null : n[0];
}
//#endregion
//#region src/getApiErrorMessage.ts
function o(t, n) {
	let r = i(t);
	if (r.items.length > 0) return r.detail;
	let a = e(e(e(t)?.response)?.data), o = a?.detail;
	if (typeof o == "string" && o.length > 0) return o;
	let s = e(a?.error)?.message;
	if (typeof s == "string" && s.length > 0) return s;
	let c = a?.message;
	return typeof c == "string" && c.length > 0 ? c : r.detail.length > 0 ? r.detail : n;
}
//#endregion
//#region src/getApiFieldErrors.ts
function s(e) {
	let { items: t } = i(e), n = {};
	for (let e of t) e.field && (n[e.field] ??= []).push(e);
	return n;
}
//#endregion
//#region src/getApiFieldErrorTexts.ts
function c(e, t) {
	let n = s(e), r = {};
	for (let e of t) {
		let t = n[e];
		t && t.length > 0 && (r[e] = t[0].detail);
	}
	return Object.keys(r).length > 0 ? r : null;
}
//#endregion
export { a as findApiErrorItem, o as getApiErrorMessage, c as getApiFieldErrorTexts, s as getApiFieldErrors, r as isApiError, n as parseApiErrorResponse, i as transformToApiError };
